/* PAINTRANGER - Ueberschrift im Cookie-Banner.

   Shopifys eigenes Cookie-Banner laesst sich im Adminbereich nicht
   umtexten. Es wird aber per Skript in die Seite gesetzt, deshalb wird
   hier nur die Ueberschrift ausgetauscht.

   Bewusst NICHT angefasst werden der Erklaertext darunter, der Link zur
   Datenschutzerklaerung und die drei Knoepfe. Die bleiben so, wie Shopify
   sie liefert: Annehmen und Ablehnen gleich gross und gleich sichtbar.

   Tut nichts, solange kein Banner angezeigt wird. */
(function () {
  var TEXTS = {
    en: 'Cookies. Sadly not the edible kind.',
    de: 'Kekse. Leider nicht die essbaren.'
  };

  function wunschtext() {
    var l = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    return TEXTS[l] || TEXTS.en;
  }

  function umbenennen() {
    var titel = document.getElementById('shopify-pc__banner__body-title');
    if (!titel) return false;
    var t = wunschtext();
    if (titel.textContent !== t) titel.textContent = t;
    return true;
  }

  if (!umbenennen()) {
    var versuche = 0;
    var timer = setInterval(function () {
      versuche++;
      if (umbenennen() || versuche > 60) clearInterval(timer);
    }, 250);
  }

  document.addEventListener('click', function () {
    setTimeout(umbenennen, 300);
  }, true);
})();
